import { render, staticRenderFns } from "./DsConfiguration.vue?vue&type=template&id=7b5ec65c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DsConfiguration.vue?vue&type=script&lang=js&"
export * from "./DsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DsConfiguration.vue?vue&type=style&index=0&id=7b5ec65c&prod&lang=scss&"
import style1 from "./DsConfiguration.vue?vue&type=style&index=1&id=7b5ec65c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ec65c",
  null
  
)

export default component.exports